import { CssBaseline, ThemeProvider } from '@material-ui/core';
import { FloatingStatusWidget } from 'app/components';
import DownloadConfirmDialogBox from 'app/components/DownloadConfirmDialogBox';
import reviewTheme from 'app/configs/reviewTheme';
import { Outlet } from 'react-router-dom';

import TaskQueue from '../components/TaskQueue';

const FullScreenLayout = () => {
  return (
    <>
      <Outlet />

      <TaskQueue />

      <ThemeProvider theme={reviewTheme}>
        <CssBaseline />

        <FloatingStatusWidget />
      </ThemeProvider>

      <DownloadConfirmDialogBox />
    </>
  );
};

export default FullScreenLayout;
